import { render, staticRenderFns } from "./ProdutoModoPedido.vue?vue&type=template&id=11e4ffaa&scoped=true"
import script from "./ProdutoModoPedido.vue?vue&type=script&lang=js"
export * from "./ProdutoModoPedido.vue?vue&type=script&lang=js"
import style0 from "./ProdutoModoPedido.vue?vue&type=style&index=0&id=11e4ffaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e4ffaa",
  null
  
)

export default component.exports